module.exports = __webpack_public_path__ + "img/cogithon_logo.076b71cc.png";